/**
 * Dynamically set favicon from URL
 */
export const applyFavicon = (faviconUrl) => {
  if (!faviconUrl) return;

  // Remove existing favicons
  const existingLinks = document.querySelectorAll("link[rel*='icon']");
  existingLinks.forEach((link) => link.remove());

  // Add new favicon
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = faviconUrl.endsWith('.ico') ? 'image/x-icon' : 'image/png';
  link.href = faviconUrl;
  document.head.appendChild(link);

  // Also for apple-touch-icon
  const appleLink = document.createElement('link');
  appleLink.rel = 'apple-touch-icon';
  appleLink.href = faviconUrl;
  document.head.appendChild(appleLink);
};

/**
 * Dynamically set page title
 */
export const applyPageTitle = (title) => {
  if (title) document.title = title;
};